import script from "./VertragIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./VertragIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/VertragIndex.css?vue&type=style&index=0&id=e6666460&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6666460"]])

export default __exports__